<template>
  <el-form
    :model="config"
    style="width: 100%">
    <el-form-item
      v-for="(list, index) in config.list"
      :label="`题目${index+1}`"
      :key="index"
      class="game-list-editor__recorder"
    >
      <el-row class="config_box">
        <el-col :span="20">
          <el-row>
            <el-col :span="8">
              <FileDialog
                v-model="list.title.image[0].image"
                :title="list.title.image[0].image"
                token-url="/upload/token"
                token-mode="type"
                width="200px"
                height="40px"
                type="image"
                preview
              >
                <span
                  slot="placeholder"
                  class="layout-placeholder"
                >
                  选择图片
                </span>
              </FileDialog>
            </el-col>
            <el-col :span="8">
              <el-row
                v-for="(audio, innerIndex) in list.title.audio"
                :key="innerIndex">
                <el-col :span="24">
                  <FileDialog
                    v-model="audio.audio"
                    :title="audio.audio"
                    token-url="/upload/token"
                    token-mode="type"
                    width="200px"
                    height="40px"
                    type="audio"
                    preview
                  >
                    <span
                      slot="placeholder"
                      class="layout-placeholder"
                    >
                      选择音频
                    </span>
                  </FileDialog>
                  <AppIcon
                    type="delete"
                    @click="() => DeleteTitle(index, innerIndex, 'audio')"
                  />
                </el-col>
              </el-row>
              <el-button
                size="small"
                icon="el-icon-plus"
                @click="AppendTitle(index, 'audio')"
              >
                添加音频资源
              </el-button>
            </el-col>
            <el-col :span="8">
              <el-row
                v-for="(text, innerIndex) in list.title.text"
                :key="innerIndex">
                <el-col :span="16">
                  <el-input
                    v-model="text.text"
                    :autosize="true"
                    type="textarea"
                    resize="none"
                    placeholder="请输入对应内容"
                  />
                </el-col>
                <el-col :span="2">
                  <AppIcon
                    type="delete"
                    @click="() => DeleteTitle(index, innerIndex, 'text')"
                  />
                </el-col>
              </el-row>
              <el-button
                size="small"
                icon="el-icon-plus"
                @click="AppendTitle(index, 'text')"
              >
                添加对应内容
              </el-button>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="2">
          <el-radio
            v-model="list.options[0].isTrue"
            label="true">正确</el-radio>
          <el-radio
            v-model="list.options[0].isTrue"
            label="false">错误</el-radio>
        </el-col>
        <el-col :span="2">
          <AppIcon
            style="font-size: 24px;"
            type="delete"
            @click="() => recorderDelete(index)"
          />
        </el-col>
      </el-row>
    </el-form-item>
    <el-form-item
      class="game-list-editor__recorder-append"
    >
      <el-button
        type="primary"
        icon="el-icon-plus"
        plain
        round
        @click="recorderAppend"
      >
        添加游戏题目
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: "TrueOrFalseConfig",
  props: {
    question: {
      type: Object,
      default: null,
    },
    list: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      config: {
        list: [
          {
            title: {
              image: [{ text: "" }],
              text: [{ text: "" }],
              audio: [{ audio: "" }],
            },
            options: [{
              image: "", text: "", audio: "", isTrue: "true",
            }],
          },
        ],
      },
      radio: "true",
    };
  },
  created() {
    if (this.list !== null) {
      this.config.list = this.list.config;
    }
  },
  methods: {
    recorderAppend() {
      const num = this.question.question_number;
      if (this.config.list.length > num - 1 && num !== 0) {
        this.$alert(`最多只能添加${num}题！`);
      } else {
        this.config.list.push({
          title: {
            image: [{ image: "" }],
            text: [{ text: "" }],
            audio: [{ audio: "" }],
          },
          options: [
            {
              image: "",
              text: "",
              audio: "",
              isTrue: "true",
            },
          ],
        });
      }
    },
    recorderDelete(index) {
      this.$confirm("是否删除题目？").then(() => {
        this.config.list.splice(index, 1);
      });
    },
    AppendTitle(index, type) {
      this.config.list[index].title[type].push({ audio: "" });
    },
    DeleteTitle(index, innerIndex, type) {
      const item = this.config.list[index].title[type];
      if (item.length > 1) {
        item.splice(innerIndex, 1);
      }
    },
  },
};
</script>

<style scoped>
  .config_box .config_box{
    padding-bottom: 10px;
    border-bottom: 1px dashed #ccc;
  }
  .game-list-editor__recorder-append{
    margin-top: 20px;
  }
  .game-list-editor__recorder{
    margin-bottom: 10px;
  }
  .el-radio{
    display: block;
    margin: 10px 0;
  }
</style>
